var scope_0 = require('/Users/brandlmax/Repositories/Aiiot/aiiot.com/aiiot/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3bcfb2419af135552db8bfd7f0b99140.js').default;
var scope_1 = require('/Users/brandlmax/Repositories/Aiiot/aiiot.com/aiiot/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4210e84d9aa4ae6f2eb9e07cf1e3d438.js').default;
var scope_2 = require('/Users/brandlmax/Repositories/Aiiot/aiiot.com/aiiot/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/acbb91309ce56e7f9c0b81e24bf38fb7.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    